import { FC } from 'react';
import { css } from '@emotion/react';
import { TeamChatTypes } from '@frontend/api-team-chat';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Checkbox, Text } from '@frontend/design-system';
import { getUserFullName } from '../../../utils';
import { ChatAvatar } from '../../common/chat-avatar/chat-avatar';

interface SenderListItemComponentProps {
  isSelfUser?: boolean;
  user: TeamChatTypes.User;
  isSelected: boolean;
  isActive?: boolean;
  onChange: (val: string) => void;
}

export const SenderListItemComponent: FC<SenderListItemComponentProps> = ({
  user,
  isSelected,
  isActive,
  isSelfUser,
  onChange,
}) => {
  const { t } = useTranslation('team-chat');
  const name = getUserFullName(user.firstName, user.lastName);
  return (
    <span css={[styles.checkboxContainer, isActive && styles.activeItem]}>
      <Checkbox
        id={`checkbox-${user.userID}`}
        name={name}
        aria-invalid={false}
        value={isSelected}
        onBlur={() => {}}
        onChange={() => onChange(user.userID)}
        onFocus={() => {}}
        active={false}
        error={false}
        tabIndex={-1}
      />
      <ChatAvatar users={[user]} showStatusAsTooltip={false} />
      <Text css={css({ overflowWrap: 'anywhere' })}>{name + (isSelfUser ? t(' (you)') : '')}</Text>
    </span>
  );
};

const styles = {
  checkboxContainer: css({
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
    padding: theme.spacing(1, 2),
  }),
  activeItem: css({
    backgroundColor: theme.colors.neutral5,
  }),
};
